export const InitialConfig = {
    defaultPath: '/empty',
    navMode: 'compact',
    elevation: 0,
    loading: false
}